/* eslint-disable eqeqeq */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
import React from "react";
import ReactDOM from "react-dom";
import { render } from "react-dom";
import $, { ajax } from "jquery";
import auth, { setDropdownButton, put, getLocale, post, messageDialog, _logError, confirmDialog, getInputDialog, choiceDialog2, getSetting, _log, ajaxCallEnd, get, featureEnabled } from "./auth";
import { getOrderById, getOrdersPaidBy, getQuantity, getTable, getTableOccupation, tmplparams, update } from "./order-list-util";
import ReactQRCode from "./react-qrcode";
import "../css/tableMatePaid.css";
import { I18n } from "react-redux-i18n";
import admin, { getMenuItem, getNonLocalPrinterForPrinterAction, getTableMate, printHtml, resultHandler } from "./admin";
import { dayClose_fiscat, dayOpen_fiscat, generate_fiscat, storno_fiscat } from "./cashiers/fiscat";
import { dayClose_sam4s, dayOpen_sam4s, generate_sam4s, storno_sam4s } from "./cashiers/sam4s";
import { generate_cashcube } from "./cashiers/cashcube";
import { generate_jotam } from "./cashiers/jotam";
import { dayClose_a234, dayOpen_a234, generate_a234, isCashRegisterOpen_a234, parseCashRegisterStatus_a234, printDayCloseReports_a234, reprintReceipt_a234, refund_a234, storno_a234 } from "./cashiers/a234";
import { dayClose_b1, dayOpen_b1, generate_b1, isCashRegisterOpen_b1, parseCashRegisterStatus_b1, printDayCloseReports_b1, reprintReceipt_b1, refund_b1, storno_b1 } from "./cashiers/b1";
import {
  dayClose_montax,
  dayOpen_montax,
  generate_montax,
  printMontaxReceipt,
  reprintMontaxReceipt,
  reprintMontaxDayClose,
  storno_montax,
  handleMontaxDayOpenResponse,
  handleMontaxDayCloseResponse,
  handleMontaxDayCloseWithCashRegisterReport,
} from "./cashiers/montax";
import { generate_sento } from "./cashiers/sento";
import StornoDialog from "../components/StornoDialog";
import { generate_flexy } from "./cashiers/flexy";
import { generate_datecs } from "./cashiers/datecs";
import { redoTableMatePaid } from "./admin/tableOccupations";
import languages from "../langs/languages";
import CashinDialog from "../components/CashinDialog";
import CashoutDialog from "../components/Cashout";
import { getOrdersToPay, tableMatePaid, tablesOverview } from "./tables-overview";
import { dayClose_sam4s2, dayOpen_sam4s2, generate_sam4s2, refund_sam4s2, storno_sam4s2 } from "./cashiers/sam4s2";
import { separateOrders } from "./order-grouping";
import _ from "lodash";
import { updateDataOnCustomerScreen } from "../main/pointOfSale/PointOfSale";
import { saveClosedTableOccupations } from "./receiptStorage";
const { admin_local } = languages;
const CASH_RETURN_TOGGLE_KEY = "cashReturnCalculationEnabled";

const isCashReturnCalculationEnabled = () => localStorage.getItem(CASH_RETURN_TOGGLE_KEY) === "true";

// Cash registers whose generate_* function can handle a receipt with only negative amounts (money paid back, e.g. bottle return).
// The cash register module itself decides how to issue it.
const isNegativeReceiptSupported = (cashRegisterType) => {
  switch (cashRegisterType) {
    case "b1":
    case "a234":
      return true;
    default:
      return false;
  }
}

export const selectCurrency = (t, event) => {
  setDropdownButton(t);

  var i = $(
    $(t)
      .parent()
      .parent()
      .prevAll("input")
  );
  var amountToPay = Number(i.attr("amountToPay"));

  i.attr("placeholder", Math.ceil((100 * Number(amountToPay)) / Number($(t).attr("exchangeRate")), 2) / 100);
  i.attr("exchangeRate", $(t).attr("exchangeRate"));
  i.attr("currency", $(t).html().trim());
  i.val("");
  i.focus();
  event.stopPropagation();
}

export const amountChanged = (t) => {
  //if (t && t.value)
  //t.value = t.value.replace(/\D/g, "");

  var nextInput = $(t).parent().parent().find("div.amountPaid:not(.hidden) input").filter((ind, t) => $(t).val() == 0);

  var amountToPay = $(t).attr("amountToPay");
  var amountPaid = 0;
  $(t).parent().parent().find("div.amountPaid:not(.hidden) input").each((ind, t) => {
    const r = $(t).val() * $(t).attr("exchangeRate");
    amountPaid += isNaN(r) ? 0 : r;
  });
  var amountPaidExchangeRate = $(t).attr("exchangeRate");
  var amountRemaingExchangeRate = nextInput.attr("exchangeRate");
  nextInput.attr("placeholder", Math.max(0, Math.round((100 * (amountToPay - amountPaid * amountPaidExchangeRate)) / amountRemaingExchangeRate) / 100));
  nextInput.attr("amountToPay", Math.round(100 * Math.max(0, amountToPay - amountPaid * amountPaidExchangeRate)) / 100);
  checkPayments();
}

export const setAmount = t => {
  var amountToPay = $($(t).parents("li")[0]).attr("amountToPay");
  var paymentMethod = getPaymentMethod($(t).parent().parent().attr("paymentmethod"));
  if (paymentMethod.method.type === "teya" && typeof localStorage.teya_terminal === "undefined") {
    selectTerminal("teya");
    return;
  }
  if (paymentMethod.method.type === "hellopay" && typeof localStorage.hellopay_terminal === "undefined") {
    selectTerminal("hellopay");
    return;
  }
  if (paymentMethod.method.type === "paynance" && typeof localStorage.paynance_terminal === "undefined") {
    selectTerminal("paynance");
    return;
  }
  var currencyid = $(t).parents('li').find(".paymentCurrency").val();
  var currency = auth.myStatus.currencies.find(c => c.id == currencyid);
  $(t).parent().parent().parent().find("> *:not(.vat-details-block) input").each((ind, t) => {
    //if (t.value === amountToPay)
    $(t).val("");
  })
  $(t).parent().parent().find("input").val(
    Math.round(100 * amountToPay / $(t).parent().parent().find("input").attr("exchangerate")) / 100
  );
  $(t).parent().parent().find("input").focus();
  $(t).parent().parent().find("input").trigger("change");
  //  checkPayments();
};

const parseAmount = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
}

const updateCashReceivedDisplay = (mateElement, cashReceivedAmount, cashReturnAmount) => {
  const currencyName = auth.myStatus.restaurant_base_currency.name;
  const received = Math.max(0, auth.round(cashReceivedAmount));
  const returned = Math.max(0, auth.round(cashReturnAmount));
  const scoped = $(mateElement).find(".cash-received-value").length ? $(mateElement) : $("#cashMediaBottom");

  scoped.find(".cash-received-value").text(received + " " + currencyName);
  scoped.find(".cash-return-value").text(returned + " " + currencyName);
}

const getActiveMateElement = () => {
  const activeMate = $("#tableMatePaidDialog li.mate.active").get(0);
  return activeMate;
}

const isCashAmountInputFocused = (mateElement) => {
  const activeElement = document.activeElement;
  if (!activeElement || activeElement.tagName !== "INPUT")
    return false;

  const activeInput = $(activeElement);
  if (!activeInput.closest(mateElement).length)
    return false;

  return activeInput.closest(".amountPaid").attr("paymentMethodType") === "cash";
}

const getCashChoiceSelectionCounts = (mateElement) => {
  try {
    const raw = $(mateElement).attr("cashChoiceSelectionCounts");
    if (!raw)
      return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch (e) {
    return {};
  }
}

const renderCashChoiceSelectionCounts = (mateElement, counts) => {
  const scoped = $("#cashMediaBottom");
  scoped.find("label[id^='banknote-'], label[id^='coin-']").each((_, label) => {
    const labelId = $(label).attr("id") || "";
    const value = Number((labelId.match(/(\d+)$/) || [])[1]);
    if (!value)
      return;
    const count = Number(counts[value] || 0);
    const badge = $(label).find(".cash-choice-count");
    if (count > 0) {
      badge.text(count + "x");
      badge.removeClass("hidden");
    } else {
      badge.addClass("hidden");
      badge.text("");
    }
  });
}

export const addCashReceivedNote = (amount) => {
  const activeMate = getActiveMateElement();
  if (!activeMate)
    return;

  const noteAmount = parseAmount(amount);
  const currentCashReceived = parseAmount($(activeMate).attr("cashReceivedAmount"));
  const nextCashReceived = currentCashReceived + noteAmount;
  $(activeMate).attr("cashReceivedAmount", nextCashReceived);

  const counts = getCashChoiceSelectionCounts(activeMate);
  counts[noteAmount] = Number(counts[noteAmount] || 0) + 1;
  $(activeMate).attr("cashChoiceSelectionCounts", JSON.stringify(counts));
  renderCashChoiceSelectionCounts(activeMate, counts);

  checkPayments();
}

export const clearCashReceivedAmount = () => {
  const activeMate = getActiveMateElement();
  if (!activeMate)
    return;

  $(activeMate).attr("cashReceivedAmount", 0);
  $(activeMate).attr("cashChoiceSelectionCounts", "{}");
  renderCashChoiceSelectionCounts(activeMate, {});
  checkPayments();
}

export const toggleCashReturnCalculation = (enabled) => {
  const wasEnabled = isCashReturnCalculationEnabled();
  localStorage.setItem(CASH_RETURN_TOGGLE_KEY, enabled ? "true" : "false");
  if (enabled && !wasEnabled)
    messageDialog(admin_local.cash_return_calculation, admin_local.cash_return_calculation_help);
  checkPayments();
  _log("Cash return calculation toggled: " + enabled);
}

export const refreshCashReturnFocusState = () => {
  const mateElement = getActiveMateElement();
  if (!mateElement)
    return;

  const cashMediaBottom = $("#cashMediaBottom");
  if (!cashMediaBottom.length)
    return;

  let cashAmount = 0;
  $(mateElement)
    .find(".main-block > div > :not(.vat-details-block) input")
    .each((_, payment) => {
      const entered = Number($(payment).val());
      if (!(entered > 0))
        return;

      const exchangeRate = Number($(payment).attr("exchangeRate") || 1);
      const paymentMethodId = $(payment).parent().find("button").attr("value");
      if (!paymentMethodId)
        return;

      const paymentMethod = getPaymentMethod(paymentMethodId);
      if (isCashLikePaymentType(paymentMethod?.method?.type))
        cashAmount += entered * exchangeRate;
    });

  const hasCashPayment = isCashReturnCalculationEnabled() && cashAmount > 0;
  if (!hasCashPayment) {
    cashMediaBottom.addClass("cash-media-inactive");
    cashMediaBottom.addClass("cash-choices-inactive");
    cashMediaBottom.removeClass("cash-choices-unfocused-accepted");
    return;
  }

  cashMediaBottom.removeClass("cash-media-inactive");
  const cashReceivedAmount = parseAmount($(mateElement).attr("cashReceivedAmount"));
  const cashInputFocused = isCashAmountInputFocused(mateElement);
  if (cashInputFocused) {
    cashMediaBottom.removeClass("cash-choices-inactive");
    cashMediaBottom.removeClass("cash-choices-unfocused-accepted");
  } else if (cashReceivedAmount > 0) {
    cashMediaBottom.removeClass("cash-choices-inactive");
    cashMediaBottom.addClass("cash-choices-unfocused-accepted");
  } else {
    cashMediaBottom.addClass("cash-choices-inactive");
    cashMediaBottom.removeClass("cash-choices-unfocused-accepted");
  }
}

export const createNewPartner = (event) => {
  const p = $(event.currentTarget).parents('.vat-details-block').find('.vat-details');
  const partnerType = p.find('#partner_type button.active').attr("id");
  var partner = p.find('input#partner_id').val();
  if (partner)
    return;
  var tax_number = partnerType === "company" ? p.find('input#tax_number').val() : "";
  var name = partnerType === "company" ? p.find('input#name').val() : p.find('input#personname').val();
  var addresss = p.find('input#address').val();
  var postcode = p.find('input#postcode').val();
  var email = p.find('input#email').val();
  var city = p.find('input#city').val();

  if ((!tax_number && partnerType === "company") || !name || !addresss || !postcode || !city)
    return;

  const partnerJSON = {
    name: name,
    address: {
      address: addresss,
      city: city,
      postCode: postcode,
      countryCode: "HU"
    },
    taxcode: tax_number,
    textType: "EMPTY",
    emails: [email],
    tax_type: partnerType === "company" ? "HAS_TAX_NUMBER" : "NO_TAX_NUMBER"
  }
  put("billingo/" + localStorage.restaurantSelected + "/partners", partnerJSON).done(partner => {
    p.find('#partner_id').val(partner.id);
    p.parent().find("#create-vat-partner").addClass("hidden");
    checkPayments();
  });
}

export const checkPayments = (orderss, tableMatePayment) => {

  var toohigh = false;
  let count = 0;
  let tableOccupation = getTableOccupation(tableMatePayment?.tableMate?.tableOccupationId || sessionStorage.tableOccupationSelected);
  if (!tableOccupation && !tableMatePayment) return;
  let tableMates = tableOccupation?.tableMates ? tableOccupation.tableMates.filter(t => t.active).filter(t => getOrdersToPay(t.id).length) : [];
  let table = getTable(tableMatePayment?.tableMate?.tableNumber || sessionStorage.tableNumberSelected);
  let pos = table.pos || table.kiosk;
  let seqnr = pos ? tableOccupation?.seqnr : undefined;
  let pcount = tableMatePayment ? tableMatePayment.payments.length : tableMates.length;
  var ok = !!$("#tableMatePaidDialog li.mate.active").length && pcount > 0;
  var allDelivered = true;
  $("#tableMatePaidDialog li.mate.active").each((ind, m) => {
    var okk = true;
    count++;
    var currentAmount = 0;
    var mateId = $(m).attr("id");
    if ($("div#pos-qrcode" + mateId + " canvas").length > 0)
      ReactDOM.unmountComponentAtNode($("div#pos-qrcode" + mateId).get(0));

    if (!$(m).hasClass("active")) return;
    var type;
    var types = [];

    var amount = Number($(m).attr("amountToPay"));
    // negative payments are only collected when the selected cash register can pay money back
    const selectedCashRegisterId = $("#cashregisters label.active > input").prop("id") || $("#cashregisters input:checked").prop("id");
    const negativeReceiptSupported = isNegativeReceiptSupported(auth.myStatus.restaurant_cash_registers.find(c => c.id == selectedCashRegisterId)?.type);
    //// eslint-disable-next-line no-eval
    var amountToPay = amount; //eval(roundFunction);

    var currency;
    var originalAmountInCurrency = 0;
    var amountPaidExchangeRate = 1;
    var paymentTypes = 0;

    var cashAmount = 0;

    $(m)
      .find(".main-block > div > :not(.vat-details-block) input")
      .each(function (ind, payment) {
        if (Number($(payment).val()) > 0 || (negativeReceiptSupported && amountToPay < 0 && Number($(payment).val()) < 0)) {
          paymentTypes++;
          amountPaidExchangeRate = $(payment).attr("exchangeRate");
          originalAmountInCurrency = Number($(payment).val());
          currency = $(payment).attr("currency") ? $(payment).attr("currency") : auth.myStatus.restaurant_base_currency.name;
          currentAmount += Number($(payment).val() * amountPaidExchangeRate);
          types.push({
            type: $(payment).parent().attr("paymentMethod"),
            amount: Number($(payment).val()),
            currency: currency,
            exchangeRate: amountPaidExchangeRate,
            terminal: $(payment).parent().attr("paymentMethodType") === "teya" ? localStorage.teya_terminal : $(payment).parent().attr("paymentMethodType") === "paynance" ? localStorage.paynance_terminal : null
          });
          const t = $(payment).parent().find("button").attr("value");
          if (t) {
            const paymentMethodType = getPaymentMethod(t)?.method?.type;
            if (isCashLikePaymentType(paymentMethodType)) {
              cashAmount += Number($(payment).val() * amountPaidExchangeRate);
            }
            if (Number($(payment).val() * amountPaidExchangeRate) >= amountToPay || isCashLikePaymentType(paymentMethodType))
              type = t;
          }
        }
      });

    /*
  if (type && types.length === 1 && getPaymentMethod(type).method.type === "cash") {
    amount = amountToPay;
    amountToPay = eval(roundFunction);
  }*/

    var tip = 0;
    var tiptype = "cash";
    tip = currentAmount - amountToPay;
    const originalTip = tip;

    if (tip > 0) {
      var tip2 = tip;
      types.sort((a, b) => {
        const pma = getPaymentMethod(a.type);
        const pmb = getPaymentMethod(b.type);
        if (pma.method.type === "cash" && pmb.method.type !== "cash")
          return -1;
        if (pma.method.type !== "cash" && pmb.method.type === "cash")
          return 1;
        return 0;
      });
      types.forEach((t, ind) => {
        if (t.amount > 0) {
          const a = Math.min(t.amount, tip2);
          if (a > 0) {
            t.amount -= a;
            tip2 -= a;
            tiptype = auth.myStatus.restaurant_payment_methods.find(m => m.id == t.type)?.method?.type;
          }
        }
      });
    }

    updateDataOnCustomerScreen({ tip: Math.max(0, auth.round(tip)), type: "update" });

    $(m)
      .find("text#tip")
      .text(Number(Math.max(0, auth.round(tip))));

    const isSinglePayer = pcount === 1;
    const cashMediaBottom = $("#cashMediaBottom");
    const cashTotalsRow = $("#cashMediaBottom .cash-totals-row");
    const cashReceivedBlock = $("#cashMediaBottom .cash-received-block");
    const cashReturnBlock = $("#cashMediaBottom .cash-return-block");
    const hasCashPayment = isCashReturnCalculationEnabled() && isSinglePayer && cashAmount > 0;
    if (hasCashPayment) {
      cashMediaBottom.removeClass("cash-media-inactive");
      const cashReceivedAmount = parseAmount($(m).attr("cashReceivedAmount"));
      const cashInputFocused = isCashAmountInputFocused(m);
      if (cashInputFocused) {
        cashMediaBottom.removeClass("cash-choices-inactive");
        cashMediaBottom.removeClass("cash-choices-unfocused-accepted");
      } else if (cashReceivedAmount > 0) {
        cashMediaBottom.removeClass("cash-choices-inactive");
        cashMediaBottom.addClass("cash-choices-unfocused-accepted");
      } else {
        cashMediaBottom.addClass("cash-choices-inactive");
        cashMediaBottom.removeClass("cash-choices-unfocused-accepted");
      }
      const nonCashPaidAmount = Math.max(0, currentAmount - cashAmount);
      const cashReturnAmount = Math.max(0, cashReceivedAmount + nonCashPaidAmount - cashAmount);
      if (cashReceivedAmount > 0) {
        cashMediaBottom.removeClass("cash-totals-inactive");
        cashReceivedBlock.removeClass("hidden");
        cashReturnBlock.removeClass("hidden");
      } else {
        cashMediaBottom.addClass("cash-totals-inactive");
        cashReceivedBlock.addClass("hidden");
        cashReturnBlock.addClass("hidden");
      }
      updateCashReceivedDisplay(m, cashReceivedAmount, cashReturnAmount);
    } else {
      cashMediaBottom.addClass("cash-media-inactive");
      cashMediaBottom.addClass("cash-choices-inactive");
      cashMediaBottom.removeClass("cash-choices-unfocused-accepted");
      cashMediaBottom.addClass("cash-totals-inactive");
      cashReceivedBlock.addClass("hidden");
      cashReturnBlock.addClass("hidden");
      updateCashReceivedDisplay(m, parseAmount($(m).attr("cashReceivedAmount")), 0);
    }

    ok = ok && Math.round(currentAmount * 100) >= Math.round(amountToPay * 100);
    okk = okk && Math.round(currentAmount * 100) >= Math.round(amountToPay * 100);
    toohigh = toohigh || currentAmount > Math.max(0, amountToPay) * 3;


    $("#cashregisters label.active > input").prop("checked", true);

    var cashregister = $("#cashregisters input:checked").prop("id");

    const serviceVat = auth.myStatus.restaurant_settings.serviceVat;

    const containerChargeItem = getSetting("takeaway.containerChargeItem");

    const registerTip = auth.myStatus.restaurant_settings["register-tip"];

    if (auth.myStatus.restaurant_cash_registers.filter(c => c.isActive && (((auth.device.platform === "browser" || auth.device.platform === "iOS") && (c.format === "rs232" || c.format === "qrcode")) || auth.device.platform === "Android")).length && !cashregister) {
      const c = $("#cashregisters label");
      if (c.length === 1) {
        c.find("input").prop("checked", true);
        c.find("input").parent().addClass("active");
        c.trigger("click");
      } else {
        auth.vibrateOk(2000);
        $("#cashregisters").removeClass("highlight-3");
        setTimeout(() => $("#cashregisters").addClass("highlight-3"), 100);
        ok = false;
        okk = false;
      }
    }

    cashregister = cashregister ? auth.myStatus.restaurant_cash_registers.find(c => c.id == cashregister) : undefined;

    var entryOrder = 0;

    if (okk && type && cashregister /*&& paymentTypes === 1*/) {
      var paymentMethod = getPaymentMethod(type);
      var orders = orderss ? orderss : getOrdersPaidBy(mateId);
      var amounts = {};
      var payable = 0;
      var containerChargeFee = 0;

      if (!orders.length)
        return;

      /*
      if (cashAmount >= 0) {
        tip = Math.max(0, tip - cashAmount);
        const t = types.find(t => getPaymentMethod(t.type).method.type === "cash");
        if (t && t.amount)
          t.amount -= (originalTip - tip);
      }*/

      var negativeOk = false;

      switch (cashregister.type) {
        case "fiscat":
          break;
        case "sam4s":
          break;
        case "cashcube":
          break;
        case "jotam":
          break;
        case "a234":
          negativeOk = true;
          break;
        case "sento":
          break;
        case "flexy":
          break;
        case "datecs":
          break;
        case "sam4s2":
          break;
      }

      const detailed = cashregister.detailed && (orders.filter(o => o.price < 0).length === 0);

      const maxwidth = 40;

      if (detailed) {

        orders.forEach((order, ind) => {
          if (order.recordState === "DELETED" || order.state === "cancelled" || order.state === "ordered" || (!orderss && order.paid))
            return;
          var key = order.menuItem.id + "-" + (order.fullPrice - Number(order.discount) - Number(order.tableMateDiscount));
          order.childOrders.filter(corder => corder.recordState !== "DELETED" && corder.state !== "cancelled").forEach(o => key += "-" + o.menuItem.id);

          if (amounts[key] == undefined) {
            var label = getQuantity(order).replace(/&nbsp;/g, " ");
            if (label.length > 7) {
              const mat = label.match(/.*\((.*)\).*/);
              if (mat)
                label = mat[1];
            }
            const name = getLocale((getMenuItem(order.menuItem.id).name)).trim();
            amounts[key] = {
              menuItem: order.menuItem.id,
              service_amount: 0,
              amount: Math.round(order.fullPrice - (order.discount + order.tableMateDiscount)),
              vat: order.vat,
              name: name.substring(0, Math.max(0, maxwidth - label.length - 1)) + " " + label,
              count: 1,
              entryOrder: entryOrder++
            };
            /*
            if (order.discount + order.tableMateDiscount !== 0) {
              amounts[key + "-" + 0] = {
                amount: -(order.discount + order.tableMateDiscount),
                vat: order.vat,
                name: order.discountComment,
                count: 1,
                entryOrder: entryOrder++
              };
            }*/
            order.childOrders.forEach((corder, ind) => {
              if (corder.recordState === "DELETED" || corder.state === "cancelled" || corder.paid)
                return;
              var clabel = getQuantity(corder).replace(/&nbsp;/g, " ");
              if (clabel.length > 7) {
                clabel = clabel.split(" ")[0];
              }
              const cname = getLocale(getMenuItem(corder.menuItem.id).name).trim();

              if (!corder.addition) {
                //amounts[key].amount += Math.round(corder.price);
              } else {
                if (corder.price < 0) {
                  //amounts[key].amount += Math.round(corder.price);
                } else {
                  amounts[key + "-" + (ind + 1)] = {
                    amount: (corder.addition ? 1 : -1) * Math.round(corder.price),
                    service_amount: 0,
                    vat: corder.vat,
                    name: (corder.addition ? "+" : "-") + cname.substring(0, Math.max(0, maxwidth - clabel.length - 2)) + " " + clabel,
                    count: 1,
                    entryOrder: entryOrder++
                  };
                  if (!corder.separate)
                    amounts[key].amount -= amounts[key + "-" + (ind + 1)].amount;
                  if (amounts[key].amount < 0) {
                    /*
                    const m = Math.min(amounts[key + "-" + (ind + 1)].amount, -amounts[key].amount);
                    amounts[key + "-" + (ind + 1)].amount -= m;
                    amounts[key].amount += m;
                    */
                    amounts[key].amount += amounts[key + "-" + (ind + 1)].amount;
                    amounts[key + "-" + (ind + 1)].amount = 0;
                  }
                }
              }
            });
          } else {
            amounts[key].count++;
            order.childOrders.filter(corder => corder.recordState !== "DELETED" && corder.state !== "cancelled").forEach((corder, ind) => {
              if (corder.recordState === "DELETED" || corder.state === "cancelled" || corder.paid)
                return;
              if (!corder.addition) {
                //amounts[key].amount -= Math.floor(corder.price);
              } else {
                amounts[key + "-" + (ind + 1)] && amounts[key + "-" + (ind + 1)].count++;
              }
              //amounts[key + "-" + (ind + 1)].count++;
            });
          }
          if (order.menuItem.id != containerChargeItem)
            payable += Math.ceil(order.fullPrice + separateOrders(order) - order.discount - order.tableMateDiscount);
          else
            containerChargeFee += order.fullPrice - order.discount - order.tableMateDiscount;
          if (order.state != "delivered") allDelivered = false;
        });

        if (registerTip) {
          const serviceFee = Math.max(0, (Number(amountToPay) - Number(payable) - containerChargeFee));
          Object.values(amounts).forEach(amount => {
            if (amount.menuItem != containerChargeItem) {
              if (serviceVat)
                amount.service_amount += Math.max(Math.round(amount.amount / (payable) * serviceFee));
              else
                amount.amount += Math.floor(amount.amount / (payable) * serviceFee);
            }
          })
        } else {
          tip = 0;
        }

      } else {
        var containerCharge = 0;
        orders.forEach(order => {
          if (order.recordState === "DELETED" || order.state === "cancelled" || (!orderss && order.paid))
            return;
          if (amounts[order.vat] == undefined) {
            amounts[order.vat] = {
              menuItem: order.menuItem.id,
              name: I18n.t("admin_local.sale") + " " + (order.vat === undefined || order.vat === null ? "TAM" : order.vat + "%"),
              amount: auth.round(order.fullPrice - order.discount - order.tableMateDiscount),
              vat: order.vat,
              entryOrder: entryOrder++,
              count: 1,
              service_amount: 0
            };
          } else amounts[order.vat].amount += auth.round(order.fullPrice - order.discount - order.tableMateDiscount);

          order.childOrders.filter(o => o.separate).forEach(corder => {
            if (corder.recordState === "DELETED" || corder.state === "cancelled")
              return;
            if (amounts[corder.vat] == undefined) {
              amounts[corder.vat] = {
                menuItem: corder.menuItem.id,
                name: I18n.t("admin_local.sale") + " " + (corder.vat === undefined || corder.vat === null ? "TAM" : corder.vat + "%"),
                amount: auth.round(corder.fullPrice),
                vat: corder.vat,
                entryOrder: entryOrder++,
                count: 1,
                service_amount: 0
              };
            } else {
              amounts[corder.vat].amount += auth.round(corder.fullPrice);
            }
          });

          if (order.menuItem.id != containerChargeItem)
            payable += order.fullPrice + separateOrders(order) - order.discount - order.tableMateDiscount;
          else
            containerCharge += order.fullPrice - order.discount - order.tableMateDiscount;
          if (order.state != "delivered") allDelivered = false;
        });

        if (registerTip) {
          const serviceFee = (amountToPay - payable - containerCharge);
          Object.keys(amounts).forEach(vat => {
            if (amounts[vat].menuItem != containerChargeItem) {
              if (serviceVat)
                amounts[vat].service_amount += Math.max(0, Math.round(amounts[vat].amount / payable * serviceFee));
              else
                amounts[vat].amount += Math.round(amounts[vat].amount / payable * serviceFee);
            }
          })
        }

      }

      payable = Math.round(payable);

      const service_fee = Object.values(amounts).reduce((a, b) => a + b.service_amount, 0);

      if (orderss) {
        if (tip > 0)
          tip -= tableMatePayment.totalAmountPaid - tableMatePayment.totalAmountPayable;

        //This is just a payment to register the tip so we have to remove the already paid parts

        Object.values(amounts).forEach(a => {
          a.amount = 0;
          a.service_amount = 0;
        })

        tableMatePayment.payments.forEach(p => {
          const payment = types.find(t => Number(t.type) === p.paymentMethod.id);
          if (payment)
            payment.amount -= p.amount;
        })

        amountToPay = 0;
      }


      if (!Object.values(amounts).find(p => (p.amount + p.service_amount > 0)) && tip == 0 && !(isNegativeReceiptSupported(cashregister.type) && Object.values(amounts).some(p => p.amount + p.service_amount < 0)))
        return;


      const total = Object.values(amounts).map(a => (a.service_amount + a.amount) * a.count).reduce((a, b) => a + b, 0);
      if (total != amountToPay && Math.abs(total - amountToPay) > 0) {
        const firstWithService = Object.values(amounts).find(p => p.service_amount > 0);
        if (firstWithService)
          firstWithService.service_amount -= (total - amountToPay) / firstWithService.count;
      }

      const total2 = Object.values(amounts).map(a => (a.service_amount + a.amount) * a.count).reduce((a, b) => a + b, 0);
      if (total2 != amountToPay) {
        console.error("NOT GOOD", total2 + "!=" + (amountToPay + tip))
      }

      $(m).attr('qrcode', "");
      if (cashregister) {
        if (paymentMethod.method.type === "card" || paymentMethod.method.type === "utalvany" || paymentMethod.method.type === "online" || paymentMethod.method.type === "barion" || paymentMethod.method.type === "hellopay" || paymentMethod.method.type === "teya" || paymentMethod.method.type === "bizpay" || paymentMethod.method.type === "paynance") showposqrcode(m, mateId, amounts, cashregister.type, amountToPay, types, amountPaidExchangeRate, cashregister.serviceVat, tip, tiptype, getTableMate(mateId), seqnr);
        else if (paymentMethod.method.type === "cash") {

          if (currency === "EUR") {
            //amounts[Object.keys(amounts)[0]].amount = Math.round((originalAmountInCurrency - tip / amountPaidExchangeRate) * 100) / 100;
            //console.log(amounts)
            showposqrcode(m, mateId, amounts, cashregister.type, payable, types, amountPaidExchangeRate, cashregister.serviceVat, tip, tiptype, getTableMate(mateId), seqnr);
          } else {
            showposqrcode(m, mateId, amounts, cashregister.type, amountToPay, types, amountPaidExchangeRate, cashregister.serviceVat, tip, tiptype, getTableMate(mateId), seqnr);
          }
        }
      }
    } else {
      if ($(m).attr('qrcode'))
        $(m).attr('qrcode', "");
    }
  });

  var allbuttons = $("#tableMatePaid button#save,#tableMatePaid button#save-and-unlock,#tableMatePaid button#print");
  var buttons = $("#tableMatePaid button#save,#tableMatePaid button#print");
  var buttons2 = $("#tableMatePaid button#save-and-unlock");

  /*
  if ($("#tableMatePaidDialog li.mate.active .vat-details-block.show").length && auth.myStatus.restaurant_settings["enabled-features"].invoice.platform === "billingo" && !$("#tableMatePaidDialog li.mate.active .vat-details-block.show #partner_id").val()) {
    ok = false;
  }*/

  const autoDeliverOnUnlock = auth.myStatus.restaurant_settings["tables-overview"]["autoDeliverOnUnlock"];
  allbuttons.prop("disabled", "true");
  if (ok) {
    if (toohigh) {
      buttons.removeAttr("disabled");
      buttons.removeClass("btn-negative");
      buttons.removeClass("btn-positive");
      buttons.addClass("btn-danger");
      if (count == pcount && (allDelivered || autoDeliverOnUnlock)) {
        buttons2.removeAttr("disabled");
        buttons2.removeClass("btn-positive");
        buttons2.removeClass("btn-negative");
        buttons2.addClass("btn-danger");
      }
    } else {
      buttons.removeAttr("disabled");
      buttons.removeClass("btn-negative");
      buttons.removeClass("btn-danger");
      buttons.addClass("btn-positive");
      if (count == pcount && (allDelivered || autoDeliverOnUnlock)) {
        buttons2.removeAttr("disabled");
        buttons2.removeClass("btn-negative");
        buttons2.removeClass("btn-danger");
        buttons2.addClass("btn-positive");
      }
    }
  } else {
    allbuttons.prop("disabled", "true");
    allbuttons.addClass("btn-negative");
    allbuttons.removeClass("btn-positive");
    allbuttons.removeClass("btn-danger");
  }
};

export const getcashregisterqrcode = (amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype, tableMate, seqnr, cashRegisterMethod) => {
  types.forEach(payment => {
    const paymentMethod = getPaymentMethod(payment.type);
    if ("cash" === paymentMethod.method.type) {
      if (payment.currency === auth.myStatus.restaurant_base_currency.name) {
        var roundFunction = auth.myStatus.restaurant_base_currency["javaScriptRoundFunction"];
        // eslint-disable-next-line no-eval
        payment.amount = eval(roundFunction.replace("amount", payment.amount));
      }
    }
  })
  var url = "";
  var def = $.Deferred();
  //console.log(cashierType);
  if (cashRegisterMethod)
    cashRegisterMethod(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype, tableMate, seqnr);
  else
    switch (cashierType) {
      case "fiscat":
      case "fiscat2":
      case "fiscat3":
      case "fiscat4":
      case "fiscat5":
        generate_fiscat(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype);
        break;
      case "sam4s":
        generate_sam4s(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype);
        break;
      case "sam4s2":
        generate_sam4s2(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype);
        break;
      case "cashcube":
        generate_cashcube(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype);
        break;
      case "jota_m":
        generate_jotam(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype);
        break;
      case "sento":
        generate_sento(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype);
        break;
      case "datecs":
        generate_datecs(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip,);
        break;
      case "flexy":
        generate_flexy(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype);
        break;
      case "a234":
        generate_a234(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype, tableMate, seqnr);
        break;
      case "b1":
        generate_b1(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype, tableMate, seqnr);
        break;
      case "montax":
        generate_montax(def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype, tableMate, seqnr);
        break;
      default:
    }
  return def.promise();
}

function showposqrcode(m, mateId, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype, tableMate, seqnr) {
  var def = getcashregisterqrcode(amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat, tip, tiptype, tableMate, seqnr);
  def.promise().done(url => {
    $(m).attr('qrcode', url);
    if (auth.myStatus.restaurant_cash_registers.filter(c => c.name === cashierType && c.format === 'qrcode').length == 0)
      return;
    ReactDOM.render(
      <ReactQRCode
        url={url}
        size={
          $("div#pos-qrcode" + mateId)
            .get(0)
            .getBoundingClientRect().height
        }
      />,
      $("div#pos-qrcode" + mateId).get(0)
    );

  });
}

export const getPaymentMethod = (id) => {
  var paymentMethod = null;
  auth.myStatus.restaurant_payment_methods.forEach(pm => {
    if (pm.method.id == id) paymentMethod = pm;
  });
  return paymentMethod;
}

export const isCashLikePaymentType = (type) => {
  const normalized = String(type ?? "").toLowerCase();
  return normalized === "cash" || normalized === "utalvany";
};

export const getRestaurantPaymentMethodsOrderedByCashRegister = (restaurantPaymentMethods) => {
  if (!Array.isArray(restaurantPaymentMethods))
    return [];

  const selectedCashRegisterId = localStorage.getItem("cashregister");
  const selectedCashRegister = auth.myStatus.restaurant_cash_registers.find(c => c.id == selectedCashRegisterId);
  const orderByPaymentMethodId = {};

  if (selectedCashRegister && Array.isArray(selectedCashRegister.paymentMethods)) {
    selectedCashRegister.paymentMethods.forEach((paymentMethod, index) => {
      const paymentMethodId = Number(paymentMethod?.id ?? paymentMethod?.method?.id);
      if (Number.isNaN(paymentMethodId))
        return;
      const orderIndex = Number(paymentMethod?.order_index);
      orderByPaymentMethodId[paymentMethodId] = Number.isNaN(orderIndex) ? index : orderIndex;
    });
  }

  return restaurantPaymentMethods.slice().sort((a, b) => {
    const idA = Number(a?.method?.id ?? a?.id);
    const idB = Number(b?.method?.id ?? b?.id);
    const orderA = orderByPaymentMethodId[idA];
    const orderB = orderByPaymentMethodId[idB];
    const hasOrderA = typeof orderA !== "undefined";
    const hasOrderB = typeof orderB !== "undefined";
    if (hasOrderA && hasOrderB)
      return orderA - orderB;
    if (hasOrderA !== hasOrderB)
      return hasOrderA ? -1 : 1;
    return String(getLocale(a?.method?.name ?? a?.name ?? "")).localeCompare(String(getLocale(b?.method?.name ?? b?.name ?? "")));
  });
}

export const getCurrencyEchangeRate = (id) => {
  var currency = null;
  auth.myStatus.restaurant_currencies.forEach(c => {
    if (c.currency.id == id) currency = c;
  });
  if (currency == null)
    return 1;
  return currency.exchangeRate;
}

export const showPayments = () => {
  var modal = $("#tableMatePaidDialog");
  modal.empty();
  $("#tableMatePaymentsTemplate")
    .tmpl({
      tableOccupation: getTableOccupation(sessionStorage.tableOccupationSelected),
      ...tmplparams()
    })
    .appendTo(modal);
  var modal = $("#tableMatePayments.modal");
  modal.show();
}

export const isThereReceiptsToPrint = () => {
  try {
    return sessionStorage.tableOccupationSelected > 0 && getTableOccupation(sessionStorage.tableOccupationSelected).tableMatePayments.filter(tmp => tmp.orderCount > 0).length > 0;
  } catch (ex) { return false };
}

export const printReceipt = (tableMatePaymentId) => {
  const tableOccupation = getTableOccupation();
  const tableMatePayment = tableOccupation.tableMatePayments.find(tmp => tmp.id === tableMatePaymentId);
  function doit() {
    getQrcodeCode(tableMatePayment).done(url => {
      var cashregister = $("#cashregisters input:checked").prop("id");
      cashregister = auth.myStatus.restaurant_cash_registers.find(c => c.id == cashregister);
      const tableMatePayments = {
        id: tableMatePaymentId,
        tableOccupation: tableOccupation.id,
        qrcode: url
      }
      postPayment(cashregister, tableOccupation.id, [tableMatePayments], true, (data) => {
        update(data);
        showPayments();
      })
    })
  }
  if (tableMatePayment.printed) {
    confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.reprint_receipt")).done(doit);
  } else
    doit();

}

export const getQrcodeCode = (m, notpaid = false, seqnr, cashRegisterMethod) => {
  /*
  _log(auth.server + '/eatwithme.server/paymentService/paynance/softposCallback');
  //eslint-disable-next-line no-undef
  cordova.plugins.PaynanceGateway.checkGateway(() => {
    //eslint-disable-next-line no-undef
    cordova.plugins.PaynanceGateway.openGateway({
      ownerAppPackage: 'eu.paynance.softpos.eatwithme',
      //ownerAppDeepLinkCallback: auth.server + '/eatwithme.server/paymentService/paynance/softposCallback?instance=' + localStorage.instance + "&paymentId=1123",
      ownerAppDeepLinkCallback: 'eatwithmeconsole://paynance',
      sessionId: '92e6e172-b3b2-4a94-bf77-0c868f4e32ba',
      sourceCode: 'ST32968223227T5LVQP2Z7CWN',
      terminalId: 'SoftPOS1743077113058',
      cashRegisterId: 'CashRegisterId',
      amount: '12000',
      currencyCode: '348',
      merchantReference: 'some-reference',
      customerTrns: 'some-reference',
      tipAmount: '2000',
      action: 'sale'
    }, function (successMsg) {
      _log(successMsg);
    }, function (errMsg) {
      _log(errMsg);
    });
  });*/



  const def = new $.Deferred();

  const orderss = (m.orders && m.orders.map(o => isNaN(o) ? o : getOrderById(o))) || m.orderIds.split(",").map(s => getOrderById(Number(s))).filter(o => o);

  var ok = true;
  var toohigh = false;
  let count = 0;
  let pcount = 0;
  var allDelivered = true;

  var okk = true;
  count++;
  var currentAmount = 0;
  var mateId = m.tableMate.id;
  pcount++;
  var type;
  var types = [];

  var amountToPay = m.totalAmountPayable;

  const containerChargeItem = getSetting("takeaway.containerChargeItem");

  var currency;
  var originalAmountInCurrency = 0;
  var amountPaidExchangeRate = 1;
  var paymentTypes = 0;

  var cashAmount = 0;

  m.payments.forEach(payment => {
    if (payment.amount > 0) {
      paymentTypes++;
      amountPaidExchangeRate = payment.rate;
      originalAmountInCurrency = payment.amount;
      currency = payment.currency.name;
      currentAmount += Number(payment.amount * amountPaidExchangeRate);
      types.push({
        type: payment.paymentMethod.id,
        amount: payment.amount,
        currency: currency,
        exchangeRate: amountPaidExchangeRate,
        terminal: payment.paymentMethod.type === "teya" ? localStorage.teya_terminal : payment.paymentMethod.type === "paynance" ? localStorage.paynance_terminal : null
      });
      const t = payment.paymentMethod;
      if (t.type === "cash") {
        cashAmount += payment.amount * amountPaidExchangeRate;
      }
      if (payment.amount * amountPaidExchangeRate >= amountToPay || t.type === "cash")
        type = t;
    }
  });

  var tip = 0;

  var amount = notpaid ? amountToPay : currentAmount - amountToPay;
  // eslint-disable-next-line no-eval
  tip = amount; //eval(roundFunction);
  const originalTip = tip;

  if (tip > 0) {
    var tip2 = tip;
    types.sort((a, b) => {
      const pma = getPaymentMethod(a.type);
      const pmb = getPaymentMethod(b.type);
      if (pma.method.type === "cash" && pmb.method.type !== "cash")
        return -1;
      if (pma.method.type !== "cash" && pmb.method.type === "cash")
        return 1;
      return 0;
    });
    types.forEach((t, ind) => {
      if (t.amount > 0) {
        const a = Math.min(t.amount, tip2);
        if (!notpaid) {
          t.amount -= a;
          tip2 -= a;
        } else {
          tip -= a;
        }
      }
    });
  }

  ok = ok && (notpaid || Math.round(currentAmount * 100) >= Math.round(amountToPay * 100));
  okk = okk && (notpaid || Math.round(currentAmount * 100) >= Math.round(amountToPay * 100));
  toohigh = toohigh || currentAmount > amountToPay * 3;

  var cashregister = m.receiptNo ? m.cashRegister?.id : $("#cashregisters input:checked").prop("id") || m.payments[0].cashRegister?.id || m.payments[0].cashRegister;

  const serviceVat = auth.myStatus.restaurant_settings.serviceVat;

  const registerTip = auth.myStatus.restaurant_settings["register-tip"];

  /*
  if (auth.myStatus.restaurant_cash_registers.filter(c => c.isActive && (((auth.device.platform === "browser" || auth.device.platform === "iOS") && (c.format === "rs232" || c.format === "qrcode")) || auth.device.platform === "Android")).length && !cashregister) {
    const c = $("#cashregisters label");
    if (c.length === 1) {
      c.find("input").prop("checked", true);
      c.trigger("click");
    } else {
      auth.vibrateOk(2000);
      $("#cashregisters").removeClass("highlight-3");
      setTimeout(() => $("#cashregisters").addClass("highlight-3"), 100);
      ok = false;
      okk = false;
    }
  }*/

  cashregister = cashregister ? auth.myStatus.restaurant_cash_registers.find(c => c.id == cashregister) : undefined;

  var entryOrder = 0;

  if (okk && type && cashregister /*&& paymentTypes === 1*/) {
    var paymentMethod = type;
    var orders = orderss ? orderss : getOrdersPaidBy(mateId);
    var amounts = {};
    var payable = 0;


    if (cashAmount >= 0) {
      tip = Math.max(0, tip - cashAmount);
      const t = types.find(t => getPaymentMethod(t.type).method.type === "cash");
      if (t && t.amount)
        t.amount -= (originalTip - tip);
    }
    const detailed = cashregister.detailed && orders.filter(o => o.price < 0).length === 0;

    if (detailed) {

      orders.forEach((order, ind) => {
        if (order.recordState === "DELETED" || order.state === "cancelled" || (!orderss && order.paid))
          return;
        var key = order.menuItem.id + "-" + (order.fullPrice - order.discount - order.tableMateDiscount);
        order.childOrders.filter(corder => corder.recordState !== "DELETED" && corder.state !== "cancelled").forEach(o => key += "-" + o.menuItem.id);

        if (amounts[key] == undefined) {
          var label = getQuantity(order).replace(/&nbsp;/g, " ");
          if (label.length > 7) {
            const mat = label.match(/.*\((.*)\).*/);
            if (mat)
              label = mat[1];
          }
          const name = getLocale((getMenuItem(order.menuItem.id).name)).trim();
          amounts[key] = {
            menuItem: order.menuItem.id,
            service_amount: 0,
            amount: Math.round(order.fullPrice + separateOrders(order) - (order.discount + order.tableMateDiscount)),
            vat: order.vat,
            name: name.substring(0, Math.max(0, 18 - label.length - 1)) + " " + label,
            count: 1,
            entryOrder: entryOrder++
          };
          order.childOrders.forEach((corder, ind) => {
            if (corder.recordState === "DELETED" || corder.state === "cancelled" || corder.paid)
              return;
            var clabel = getQuantity(corder).replace(/&nbsp;/g, " ");
            if (clabel.length > 7) {
              clabel = clabel.split(" ")[0];
            }
            const cname = getLocale(getMenuItem(corder.menuItem.id).name).trim();
            if (!corder.addition) {
              //amounts[key].amount -= corder.price;
            } else {
              if (!corder.addition) {
                //amounts[key].amount += Math.round(corder.price);
              } else {
                amounts[key + "-" + (ind + 1)] = {
                  amount: (corder.addition ? 1 : -1) * Math.round(corder.price),
                  service_amount: 0,
                  vat: corder.vat,
                  name: (corder.addition ? "+" : "-") + cname.substring(0, Math.max(0, 18 - clabel.length - 2)) + " " + clabel,
                  count: 1,
                  entryOrder: entryOrder++
                };
                amounts[key].amount -= amounts[key + "-" + (ind + 1)].amount;
                if (amounts[key].amount < 0) {
                  /*
                  const m = Math.min(amounts[key + "-" + (ind + 1)].amount, -amounts[key].amount);
                  amounts[key + "-" + (ind + 1)].amount -= m;
                  amounts[key].amount += m;
                  */
                  amounts[key].amount += amounts[key + "-" + (ind + 1)].amount;
                  amounts[key + "-" + (ind + 1)].amount = 0;
                }
              }
            }
          });
        } else {
          amounts[key].count++;
          order.childOrders.filter(corder => corder.recordState !== "DELETED" && corder.state !== "cancelled").forEach((corder, ind) => {
            if (corder.recordState === "DELETED" || corder.state === "cancelled" || corder.paid)
              return;
            if (!corder.addition) {
            } else {
              amounts[key + "-" + (ind + 1)].count++;
            }
          });
        }
        payable += order.fullPrice + separateOrders(order) - order.discount - order.tableMateDiscount;
        if (order.state != "delivered") allDelivered = false;
      });

      if (notpaid === false) {
        amountToPay = payable;
      }

      // var vattip = 0;
      //console.log(amountToPay, payable);
      if (registerTip) {
        const serviceFee = (amountToPay - payable);
        Object.values(amounts).forEach(amount => {
          if (amount.menuItem != containerChargeItem) {
            if (serviceVat)
              amount.service_amount += Math.max(Math.round(amount.amount / payable * serviceFee));
            else
              amount.amount += Math.round(amount.amount / payable * serviceFee);
          }
        })
      }

    } else {
      orders.forEach(order => {
        if (order.recordState === "DELETED" || order.state === "cancelled" || (!orderss && order.paid))
          return;
        if (amounts[order.vat] == undefined) {
          amounts[order.vat] = {
            name: I18n.t("admin_local.sale") + " " + (order.vat === null ? "TAM" : order.vat + "%"),
            amount: Math.round(order.fullPrice - order.discount - order.tableMateDiscount),
            vat: order.vat,
            entryOrder: entryOrder++,
            count: 1,
            service_amount: 0
          };
        } else amounts[order.vat].amount += Math.round(order.fullPrice - order.discount - order.tableMateDiscount);
        payable += order.fullPrice - order.discount - order.tableMateDiscount;
        if (order.state != "delivered") allDelivered = false;
      });

      if (registerTip) {
        const serviceFee = (amountToPay - payable);
        Object.keys(amounts).forEach(vat => {
          if (serviceVat)
            amounts[vat].service_amount += Math.max(0, Math.round(amounts[vat].amount / payable * serviceFee));
          else
            amounts[vat].amount += Math.round(amounts[vat].amount / payable * serviceFee);
        })
      }

    }

    const total = Object.values(amounts).map(a => (a.service_amount + a.amount) * a.count).reduce((a, b) => a + b, 0);
    if (total != amountToPay && Math.abs(total - amountToPay) > 0) {
      Object.values(amounts)[0].service_amount -= (total - amountToPay) / Object.values(amounts)[0].count;
    }

    const total2 = Object.values(amounts).map(a => (a.service_amount + a.amount) * a.count).reduce((a, b) => a + b, 0);
    if (total2 != amountToPay) {
      console.error("NOT GOOD", total2, "!=", amountToPay + tip)
    }

    $(m).attr('qrcode', "");
    if (cashregister) {
      getcashregisterqrcode(amounts, cashregister.type, payable, types, amountPaidExchangeRate, serviceVat, tip, undefined, m.tableMate, seqnr, cashRegisterMethod).done(def.resolve);
    }
  } else {
    def.reject();
  }
  return def.promise();
}

const extractA234Status = (response) => {
  if (typeof response === "string") {
    const match = response.match(/<Status>([^<]+)<\/Status>/i);
    if (match)
      return match[1];
  }
  if (response && typeof response === "object") {
    const nestedStatus = response.responses?.[0]?.Response?.Status;
    if (typeof nestedStatus === "string")
      return nestedStatus;
    if (typeof response.Response?.Status === "string")
      return response.Response.Status;
  }
  return null;
};

const getA234ParsedStatus = (response) => parseCashRegisterStatus_a234(extractA234Status(response));

export const dayOpen = (cashRegister) => {
  var c;

  if (!cashRegister) {
    cashRegister = Number($("#cashregisters input:checked").prop("id"));
    c = auth.myStatus.restaurant_cash_registers.find(c => c.id === cashRegister);
  } else {
    c = auth.myStatus.restaurant_cash_registers.find(r => r.name === cashRegister);
  }

  getInputDialog(I18n.t("admin_local.cashier_dayopen"), I18n.t("admin_local.cashier_open_amount"), 0, "number").done((choice, amount) => {
    var text = "";
    var pattern = "";
    var requestOptions = null;
    switch (c.type) {
      case "fiscat":
      case "fiscat2":
      case "fiscat3":
      case "fiscat3a":
      case "fiscat4":
      case "fiscat5":
        var { text, pattern } = dayOpen_fiscat(amount);
        break;
      case "sam4s":
        var { text, pattern } = dayOpen_sam4s(amount);
        break;
      case "sam4s2":
        var { text, pattern } = dayOpen_sam4s2(amount);
        break;
      case "cashcube":
        break;
      case "jota_m":
        break;
      case "sento":
        break;
      case "a234":
        var { text, pattern } = dayOpen_a234(amount);
        break;
      case "b1":
        var { text, pattern } = dayOpen_b1(amount);
        break;
      case "montax":
        var { text, pattern, requestOptions } = dayOpen_montax(amount, c);
        break;
      default:
    }

    if (!text)
      return;

    sendToCashier(c, text, pattern, false, (response) => {
      if (c.type === "montax") {
        handleMontaxDayOpenResponse(c, response, sendToCashier, false);
        return;
      }
      if (c.type !== "a234" && c.type !== "b1")
        return;
      const parsed = getA234ParsedStatus(response);
      if (parsed.coverOpen) {
        messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.cover-open"));
        return;
      }
      if (parsed.outOfPaper) {
        messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.out-of-paper"));
        return;
      }
      if (parsed.open) {
        messageDialog(I18n.t("local.warning"), I18n.t("admin_local.cashier_day_already_opened"));
      }
    }, (response) => {
      if (c.type === "montax") {
        handleMontaxDayOpenResponse(c, response, sendToCashier, true);
        return;
      }
      if (c.type === "a234" || c.type === "b1") {
        const parsed = getA234ParsedStatus(response);
        if (parsed.coverOpen) {
          messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.cover-open"));
          return;
        }
        if (parsed.outOfPaper) {
          messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.out-of-paper"));
          return;
        }
        if (parsed.open) {
          messageDialog(I18n.t("local.warning"), I18n.t("admin_local.cashier_day_already_opened"));
          return;
        }
      }

      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.kiosk_cash_register_communication_unsuccessful"));
    }, requestOptions);
  })
}

// a234 and b1: asks for the period (yesterday by default) and prints the electronic journal text of the device for it.
const reprintFiscalMemoryReport = (c) => {
  const pad = (n) => String(n).padStart(2, "0");
  const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
  const toInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  const values = { fiscalReportFrom: toInput(yesterday), fiscalReportTo: toInput(yesterday) };
  const onChange = (event) => {
    values[event.target.id] = $(event.target).val();
  };
  const inputStyle = "font-size:inherit;margin-top:10px";
  const message = I18n.t("admin_local.cashier_fiscal_report_period")
    + `<br/>${I18n.t("admin_local.cashier_day_close_history_from")}<input type="date" id="fiscalReportFrom" class="form-control" style="${inputStyle}" value="${values.fiscalReportFrom}"/>`
    + `<br/>${I18n.t("admin_local.cashier_day_close_history_to")}<input type="date" id="fiscalReportTo" class="form-control" style="${inputStyle}" value="${values.fiscalReportTo}"/>`;

  $(document).on("input.fiscalReportDialog change.fiscalReportDialog", "#fiscalReportFrom,#fiscalReportTo", onChange);
  choiceDialog2(I18n.t("admin_local.cashier_day_close_history_title"), message, ["local.ok"]).done(() => {
    const from = new Date(`${values.fiscalReportFrom}T00:00:00`);
    const to = new Date(`${values.fiscalReportTo}T00:00:00`);
    if (isNaN(from.getTime()) || isNaN(to.getTime()) || from > to) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.cashier_fiscal_report_period_invalid"));
      return;
    }
    const { text, pattern } = c.type === "b1"
      ? printDayCloseReports_b1(from, to)
      : printDayCloseReports_a234(from, to);
    sendToCashier(c, text, pattern, false, null, () => {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.kiosk_cash_register_communication_unsuccessful"));
    });
  }).always(() => {
    $(document).off(".fiscalReportDialog");
  });
};

export const dayCloseReprint = () => {
  const cashRegisterId = Number($("#cashregisters input:checked").prop("id"));
  const c = auth.myStatus.restaurant_cash_registers.find(r => r.id === cashRegisterId);
  if (c && c.type === "montax") {
    reprintMontaxDayClose(c, sendToCashier);
  } else if (c && (c.type === "a234" || c.type === "b1")) {
    reprintFiscalMemoryReport(c);
  }
};

export const dayClose = (cashRegister) => {
  var c;

  if (!cashRegister) {
    cashRegister = Number($("#cashregisters input:checked").prop("id"));
    c = auth.myStatus.restaurant_cash_registers.find(c => c.id === cashRegister);
  } else {
    c = auth.myStatus.restaurant_cash_registers.find(r => r.name === cashRegister);
  }

  var text = "";
  var pattern = "";
  var requestOptions = null;
  switch (c.type) {
    case "fiscat":
    case "fiscat2":
    case "fiscat3":
    case "fiscat3a":
    case "fiscat4":
    case "fiscat5":
      var { text, pattern } = dayClose_fiscat();
      break;
    case "sam4s":
      var { text, pattern } = dayClose_sam4s();
      break;
    case "sam4s2":
      var { text, pattern } = dayClose_sam4s2();
      break;
    case "cashcube":
      break;
    case "jota_m":
      break;
    case "sento":
      break;
    case "datecs":
      break;
    case "a234":
      var { text, pattern } = dayClose_a234();
      break;
    case "b1":
      var { text, pattern } = dayClose_b1();
      break;
    case "montax":
      var { text, pattern, requestOptions, cashRegisterReport } = dayClose_montax(c);
      break;
    default:
  }

  if (!text)
    return;

  if (c.type === "montax" && handleMontaxDayCloseWithCashRegisterReport(c, cashRegisterReport, text, pattern, requestOptions, sendToCashier)) {
    return;
  }

  sendToCashier(c, text, pattern, false, (response) => {
    if (c.type === "montax") {
      handleMontaxDayCloseResponse(c, response, sendToCashier, false);
      return;
    }
    if (c.type !== "a234" && c.type !== "b1")
      return;
    let parsed;
    if (c.type === "a234") {
      parsed = getA234ParsedStatus(response);
    } else if (c.type === "b1") {
      parsed = parseCashRegisterStatus_b1(response);
    }
    if (parsed.coverOpen) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.cover-open"));
      return;
    }
    if (parsed.outOfPaper) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.out-of-paper"));
      return;
    }
    if (parsed.open === true) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.cashier_day_close_failed"));
    } else if (parsed.open === false) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.cashier_day_closed"));
    } else {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.kiosk_cash_register_communication_unsuccessful"));
    }
  }, (response) => {
    if (c.type === "montax") {
      handleMontaxDayCloseResponse(c, response, sendToCashier, true);
      return;
    }
    if (c.type !== "a234" && c.type !== "b1") {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.kiosk_cash_register_communication_unsuccessful"));
      return;
    }

    let parsed;
    if (c.type === "a234") {
      parsed = getA234ParsedStatus(response);
    } else if (c.type === "b1") {
      parsed = parseCashRegisterStatus_b1(response);
    }
    if (parsed.coverOpen) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.cover-open"));
      return;
    }
    if (parsed.outOfPaper) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.printer_errors.out-of-paper"));
      return;
    }
    if (parsed.open === true) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.cashier_day_close_failed"));
      return;
    } else if (parsed.open === false) {
      messageDialog(I18n.t("local.warning"), I18n.t("admin_local.cashier_day_closed"));
      return;
    }

    messageDialog(I18n.t("local.warning"), I18n.t("admin_local.kiosk_cash_register_communication_unsuccessful"));
  }, requestOptions);
}

export const getCashRegisterOpenCommand = (cashRegister) => {
  if (!cashRegister || !cashRegister.type)
    return null;

  switch (cashRegister.type) {
    case "a234":
      return isCashRegisterOpen_a234();
    case "b1":
      return isCashRegisterOpen_b1();
    default:
      return null;
  }
}

export const storno = (tableOccupationId, tableMatePaymentId, receiptNo, cashRegister = Number($("#cashregisters input:checked").prop("id"))) => {

  function onChange(event) {
    console.log(event);
  }

  var getTableOccupationByTableMatePaymentIdTimeout
  const receiptNoChanged = (newReceiptNo) => {
    const def = $.Deferred();
    //test if format is dddd/ddddd
    if (newReceiptNo.match(/^\d{4}\/\d{5}$/) == null) {
      newReceiptNo = newReceiptNo.replaceAll("ö", "0").replaceAll("=", "&").replaceAll("ó", "=");
      //httpsÉ--restaurant.eatwithme.onlineÉ8444-feedback.html_ró4=tó3=mó681=qó785922ö3ö948ö497152=pó665
      // 8 chars long number
      //take the last numbers after the last non digit if starts with https or like ööööö673

      var tableMatePaymentId = "";
      if (newReceiptNo.startsWith("https")) {
        const parts = newReceiptNo.split(/[^0-9]/);
        tableMatePaymentId = parts[parts.length - 1];

      } else if (newReceiptNo.match(/(\d{8,})$/)) {
        const mat = newReceiptNo.match(/(\d{7,})\d$/);
        tableMatePaymentId = mat[1];
      }
      if (tableMatePaymentId && !isNaN(tableMatePaymentId)) {
        if (getTableOccupationByTableMatePaymentIdTimeout) {
          clearTimeout(getTableOccupationByTableMatePaymentIdTimeout);
        }
        getTableOccupationByTableMatePaymentIdTimeout = setTimeout(() => {
          getTableOccupationByTableMatePaymentIdTimeout = null;
          get("adminService/" + localStorage.restaurantSelected + "/getTableOccupationByTableMatePaymentId/" + tableMatePaymentId, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false).done(tableOccupation => {
            tableMatePayment = tableOccupation.tableMatePayments.find(tmp => tmp.id === Number(tableMatePaymentId));
            if (!tableMatePayment) {
              def.resolve({ tableMatePayment: null, tableOccupation: null, receiptNo: "" });
              return;
            }
            tableMatePayment.orders = tableOccupation.orders.filter(o => tableMatePayment.orderIds.split(",").find(oo => oo == o.id));
            def.resolve({ tableMatePayment, tableOccupation, receiptNo: tableMatePayment.receiptNo || "" });
          }).fail(() => {
            auth.ajaxError = false;
            def.resolve({ tableMatePayment: null, tableOccupation: null, receiptNo: "" });
          });
        }, 200);
      } else {
        def.reject();
      }
      return def.promise();
    }
    get("adminService/" + localStorage.restaurantSelected + "/getTableOccupationByReceiptNo/" + cashRegister + "/" + newReceiptNo, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false).done(tableOccupation => {
      tableMatePayment = tableOccupation.tableMatePayments.find(tmp => tmp.receiptNo === newReceiptNo);
      if (!tableMatePayment)
        def.reject();
      tableMatePayment.orders = tableOccupation.orders.filter(o => tableMatePayment.orderIds.split(",").find(oo => oo == o.id));
      def.resolve({ tableMatePayment, tableOccupation });
    }).fail(() => {
      auth.ajaxError = false;
      def.reject();
    });
    receiptNo = newReceiptNo;
    return def.promise();
  }

  var def = $.Deferred();
  const dialog = $("<div id='dialog'/>");
  const def2 = $.Deferred();


  var tableMatePayment;

  if (tableMatePaymentId) {
    admin.getTableOccupationWithOrders(tableOccupationId, tableOccupations => {
      var tableOccupation = tableOccupations[0];
      if (!tableOccupation)
        return;
      tableMatePayment = tableOccupation.tableMatePayments.find(tmp => tmp.id === tableMatePaymentId);
      if (!tableMatePayment)
        return;
      tableMatePayment.orders = tableOccupation.orders.filter(o => tableMatePayment.orderIds.split(",").find(oo => oo == o.id));
      $("body").append(dialog);
      render(<StornoDialog def={def} tableMatePayment={tableMatePayment} tableOccupation={tableOccupation} receiptNoChanged={receiptNoChanged} receiptNo={receiptNo} buttons={[I18n.t("local.ok")]} show={true} container={dialog.get(0)} />, dialog.get(0));
      def.promise().always(() => {
        dialog.remove();
      })

    });
  } else {
    $("body").append(dialog);
    render(<StornoDialog def={def} receiptNoChanged={receiptNoChanged} receiptNo={receiptNo} buttons={[I18n.t("local.ok")]} show={true} container={dialog.get(0)} />, dialog.get(0));
    def.promise().always(() => {
      dialog.remove();
    })

  }

  def.promise().done(data => {
    var cashregister = data?.tableMatePayment?.cashRegister?.id || cashRegister || Number($("#cashregisters input:checked").prop("id"));
    tableMatePayment = data?.tableMatePayment || tableMatePayment;
    tableMatePaymentId = tableMatePayment?.id || tableMatePaymentId;
    const c = auth.myStatus.restaurant_cash_registers.find(r => r.id === cashregister);
    var text = "";
    if (!c)
      return;
    switch (data.mode) {
      case "storno":
        switch (c.type) {
          case "fiscat":
          case "fiscat2":
          case "fiscat3":
          case "fiscat3a":
          case "fiscat4":
          case "fiscat5":
            text = storno_fiscat(data);
            break;
          case "sam4s":
            text = storno_sam4s(data);
            break;
          case "sam4s2":
            getQrcodeCode(tableMatePayment, undefined, undefined, (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => storno_sam4s2(data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat)).done(text => {
              if (text) {
                if (c.format === "http" || c.format === "rs232")
                  post("adminService/" + localStorage.restaurantSelected + "/storno?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                    {
                      id: tableMatePaymentId,
                      qrcode: text
                    }
                  ).done(data => {
                    if (data.error) {
                      messageDialog(I18n.t("local.error"), I18n.t(data.error));
                    } else {
                      def2.resolve(data);
                    }
                  }).fail(() => {
                    auth.ajaxError = false;
                    def2.reject();
                  });
                else
                  sendToCashier(c, text);
              }
            });
            return;
            break;
          case "cashcube":
            //text = dayClose_cashcube();
            break;
          case "jota_m":
            //text = dayClose_jotam();
            break;
          case "sento":
            //text = dayClose_sento();
            break;
          case "a234":
            if (tableMatePayment) {
              getQrcodeCode(tableMatePayment, undefined, undefined, (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => storno_a234(data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat)).done(text => {
                if (text) {
                  if (c.format === "http" || c.format === "rs232")
                    post("adminService/" + localStorage.restaurantSelected + "/storno?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                      {
                        id: tableMatePaymentId,
                        qrcode: text
                      }
                    ).done(data => {

                      if (data.error) {
                        messageDialog(I18n.t("local.error"), I18n.t(data.error));
                      } else {
                        def2.resolve(data);
                      }


                    }).fail(() => {
                      auth.ajaxError = false;
                      def2.reject();
                    });
                  else
                    sendToCashier(c, text);
                }
              });
            } else {
              const def = $.Deferred();
              def.promise().done(text => {
                if (text) {
                  if (c.format === "http" || c.format === "rs232")
                    post("adminService/" + localStorage.restaurantSelected + "/sendToCashier?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                      {
                        id: tableMatePaymentId,
                        qrcode: text
                      }
                    ).done(data => {

                      def2.resolve(data);

                    }).fail(() => {
                      auth.ajaxError = false;
                      def2.reject();
                    });
                  else
                    sendToCashier(c, text);
                }
              })
              storno_a234(data, def);

            };
            return;
          case "montax":
            if (tableMatePayment) {
              const montaxDef = $.Deferred();
              montaxDef.promise().done(text => {
                post("adminService/" + localStorage.restaurantSelected + "/storno?cashregister=" + c.id + "&lang=" + localStorage.language,
                  {
                    id: tableMatePaymentId,
                    qrcode: text
                  }
                ).done(response => {
                  if (response.error) {
                    messageDialog(I18n.t("local.error"), I18n.t(response.error));
                  } else {
                    def2.resolve(response);
                  }
                }).fail(() => {
                  auth.ajaxError = false;
                  def2.reject();
                });
              });
              storno_montax(data, montaxDef, c);
            }
            return;
          case "b1":
            if (tableMatePayment) {
              getQrcodeCode(tableMatePayment, undefined, undefined, (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => storno_b1(data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat)).done(text => {
                if (text) {
                  if (c.format === "http" || c.format === "rs232")
                    post("adminService/" + localStorage.restaurantSelected + "/storno?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                      {
                        id: tableMatePaymentId,
                        qrcode: text
                      }
                    ).done(data => {

                      if (data.error) {
                        messageDialog(I18n.t("local.error"), I18n.t(data.error));
                      } else {
                        def2.resolve(data);
                      }


                    }).fail(() => {
                      auth.ajaxError = false;
                      def2.reject();
                    });
                  else
                    sendToCashier(c, text);
                }
              });
            } else {
              const def = $.Deferred();
              def.promise().done(text => {
                if (text) {
                  if (c.format === "http" || c.format === "rs232")
                    post("adminService/" + localStorage.restaurantSelected + "/sendToCashier?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                      {
                        id: tableMatePaymentId,
                        qrcode: text
                      }
                    ).done(data => {

                      def2.resolve(data);

                    }).fail(() => {
                      auth.ajaxError = false;
                      def2.reject();
                    });
                  else
                    sendToCashier(c, text);
                }
              })
              storno_b1(data, def);

            };
            return;
          default:
        }
        break;
      case "refund":
        if (tableMatePayment) {
          tableMatePayment = JSON.parse(JSON.stringify(tableMatePayment));
          tableMatePayment.payments = [{
            amount: data.totalPrice,
            currency: auth.myStatus.restaurant_base_currency.id,
            cashRegister: c.id,
            rate: 1,
            paymentMethod: auth.myStatus.restaurant_payment_methods.find(m => m.method.type === data.paymentMethod && m.isActive).method,
            terminal: "",
            softPos: false
          }]
          tableMatePayment.totalAmountPayable = data.totalPrice;
          tableMatePayment.orders = tableMatePayment.orders.filter(o => data.ordersSelected.find(os => os == o.id));
          switch (c.type) {
            case "fiscat":
            case "fiscat2":
            case "fiscat3":
            case "fiscat3a":
            case "fiscat4":
            case "fiscat5":
              break;
            case "sam4s":
              break;
            case "sam4s2":
              //clone the tableMatePayment to avoid modifying the original one
              getQrcodeCode(tableMatePayment, false, undefined, (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => refund_sam4s2(data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat)).done(text => {
                if (text) {
                  if (c.format === "http" || c.format === "rs232")
                    post("adminService/" + localStorage.restaurantSelected + "/refund?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                      {
                        id: tableMatePaymentId,
                        qrcode: text,
                        orders: data.ordersSelected,
                        payments: [{
                          amount: data.totalPrice,
                          currency: auth.myStatus.restaurant_base_currency.id,
                          cashRegister: c.id,
                          exchangeRate: 1,
                          paymentMethod: auth.myStatus.restaurant_payment_methods.find(m => m.method.type === data.paymentMethod && m.isActive)?.method?.id,
                          terminal: "",
                          softPos: false
                        }]
                      }
                    ).done(data => {
                      if (data.error) {
                        messageDialog(I18n.t("local.error"), I18n.t(data.error));
                      } else {
                        def2.resolve(data);
                      }
                    }).fail(() => {
                      auth.ajaxError = false;
                      def2.reject();
                    });
                  else
                    sendToCashier(c, text);
                }
              });
              return;
              break;
            case "cashcube":
              break;
            case "jota_m":
              break;
            case "sento":
              break;
            case "a234":
              getQrcodeCode(tableMatePayment, false, undefined, (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => refund_a234(data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat)).done(text => {
                if (text) {
                  if (c.format === "http" || c.format === "rs232")
                    post("adminService/" + localStorage.restaurantSelected + "/refund?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                      {
                        id: tableMatePaymentId,
                        qrcode: text,
                        orders: data.ordersSelected,
                        payments: [{
                          amount: data.totalPrice,
                          currency: auth.myStatus.restaurant_base_currency.id,
                          cashRegister: c.id,
                          exchangeRate: 1,
                          paymentMethod: auth.myStatus.restaurant_payment_methods.find(m => m.method.type === data.paymentMethod && m.isActive)?.method?.id,
                          terminal: "",
                          softPos: false
                        }]
                      }
                    ).done(data => {

                      if (data.error) {
                        messageDialog(I18n.t("local.error"), I18n.t(data.error));
                      } else {
                        def2.resolve(data);
                      }


                    }).fail(() => {
                      auth.ajaxError = false;
                      def2.reject();
                    });
                  else
                    sendToCashier(c, text);
                }
              });
              return;
            case "b1":
              getQrcodeCode(tableMatePayment, false, undefined, (def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat) => refund_b1(data, def, amounts, cashierType, payable, types, amountPaidExchangeRate, serviceVat)).done(text => {
                if (text) {
                  if (c.format === "http" || c.format === "rs232")
                    post("adminService/" + localStorage.restaurantSelected + "/refund?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language,
                      {
                        id: tableMatePaymentId,
                        qrcode: text,
                        orders: data.ordersSelected,
                        payments: [{
                          amount: data.totalPrice,
                          currency: auth.myStatus.restaurant_base_currency.id,
                          cashRegister: c.id,
                          exchangeRate: 1,
                          paymentMethod: auth.myStatus.restaurant_payment_methods.find(m => m.method.type === data.paymentMethod && m.isActive)?.method?.id,
                          terminal: "",
                          softPos: false
                        }]
                      }
                    ).done(data => {

                      if (data.error) {
                        messageDialog(I18n.t("local.error"), I18n.t(data.error));
                      } else {
                        def2.resolve(data);
                      }


                    }).fail(() => {
                      auth.ajaxError = false;
                      def2.reject();
                    });
                  else
                    sendToCashier(c, text);
                }
              });
              return;
            default:
          }
          break;
        }
      default:
    }

    if (text) {
      if (c.format === "http" || c.format === "rs232")
        post("adminService/" + localStorage.restaurantSelected + "/sendToCashier?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language, text).done(data => { });
      else
        sendToCashier(c, text);

    }


  })
  return def2.promise();

}

export const cashin = () => {

  function onChange(event) {
    console.log(event);
  }

  var def = $.Deferred();
  const dialog = $("<div id='dialog'/>");
  $("body").append(dialog);
  render(<CashinDialog def={def} buttons={[I18n.t("local.ok")]} show={true} container={dialog.get(0)} />, dialog.get(0));
  def.promise().always(() => {
    dialog.remove();
  })
  return def.promise();

}

export const cashout = () => {

  function onChange(event) {
    console.log(event);
  }

  var def = $.Deferred();
  const dialog = $("<div id='dialog'/>");
  $("body").append(dialog);
  render(<CashoutDialog def={def} buttons={[I18n.t("local.ok")]} show={true} container={dialog.get(0)} />, dialog.get(0));
  def.promise().always(() => {
    dialog.remove();
  })
  return def.promise();

}

export const sendToCashier = (c, text, pattern = null, isModal = true, successHandler = null, failHandler = null, requestOptions = null) => {
  let settled = false;
  const resolveOnce = (data) => {
    if (settled)
      return;
    settled = true;
    if (successHandler)
      successHandler(data);
  };
  const rejectOnce = (data) => {
    if (settled)
      return;
    settled = true;
    if (failHandler)
      failHandler(data);
  };

  if (c && (c.format === "android_http" || c.format === "android" || c.format === "android_bluetooth" || c.format === "android_rs232") && (auth.device.platform === "android" || auth.device.platform === "Android")) {
    if (c.format === "android_bluetooth") {
      //eslint-disable-next-line no-undef
      if (typeof bluetoothSerial === "undefined") {
        console.error("Bluetooth serial is not available");
        messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_adapter"));
        rejectOnce("Bluetooth serial is not available");
        return;
      }
      //eslint-disable-next-line no-undef
      bluetoothSerial.requestPermission(success => {
        //eslint-disable-next-line no-undef
        bluetoothSerial.list(success => {
          const serial = success.filter(c => c.name.startsWith("ECR-") || c.name.startsWith("VVLPTG"));
          if (serial.length === 1) {
            //eslint-disable-next-line no-undef
            bluetoothSerial.connect(serial[0].address, connectSuccess => {
              if (auth.myStatus.restaurant_cash_registers.find(cc => cc.id == c.id).type !== "cashcube")
                text = text.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
              //eslint-disable-next-line no-undef
              bluetoothSerial.write(text + "\r\n", function success() {
                //eslint-disable-next-line no-undef
                bluetoothSerial.disconnect(function success() {
                  resolveOnce(true);
                }, function error() {
                  console.error("Bluetooth Serial failed to close");
                  resolveOnce(true);
                })
              }, function error() {
                console.error("Serial failed to write");
                //eslint-disable-next-line no-undef
                bluetoothSerial.disconnect(function success() { }, function error() {
                  console.error("Bluetooth Serial failed to close");
                });
                rejectOnce(false);
              });
            }, connectFailure => {
              console.error("Bluetooth serial not", connectFailure)
              rejectOnce(connectFailure);
            });
          } else {
            if (serial.length > 1)
              messageDialog(I18n.t("local.warning"), I18n.t("admin_local.too_many_bluetooth_cashiers"));
            else
              messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_cashiers"));
            rejectOnce(false);
          }
        }, failure => {
          console.error("Bluetooth serial error", JSON.stringify(failure));
          rejectOnce(failure);
        });
      }, failure => {
        console.error("Bluetooth permission denied", JSON.stringify(failure));
        rejectOnce(failure);
      });
    } else if (c.format === "android") {
      const opts = {
        baudRate: 9600,
        //dtr: true,
        //rts: true,
        sleepOnPause: false
      }
      if (c && c.type === "jota_m")
        opts.parity = 1;

      //eslint-disable-next-line no-undef
      serial.requestPermission(opts, function success() {
        console.log("Serial granted");
        //eslint-disable-next-line no-undef
        serial.open(opts, function success() {
          _log("Serial openned!");
          //eslint-disable-next-line no-undef
          serial.write(text + 0x00, function success(successMessage) {
            console.error("Serial write:" + successMessage);
            setTimeout(() => {
              //eslint-disable-next-line no-undef
              serial.close(function success() {
                console.error("Serial closed");
                resolveOnce(successMessage);
              }, function error() {
                console.error("Serial failed to close");
                resolveOnce(successMessage);
              })
            }, 8000);
          }, function error() {
            console.error("Serial failed to write");
            //eslint-disable-next-line no-undef
            serial.close(function success() { }, function error() {
              console.error("Serial failed to close");
            });
            rejectOnce(false);
          });
        }, function error(error) {
          console.error("Serial failed to open(0)", error);
          rejectOnce(error);
        });
      }, function error(error) {
        console.error("Serial denied", error);
        rejectOnce(error);
      });
    } else if (c.format === "android_rs232") {
      //eslint-disable-next-line no-undef
      uart.list(dev => {
        _log(text);
        //eslint-disable-next-line no-undef
        uart.write({ dev: dev, text: text }, function success(successMessage) {
          console.error("Serial write:" + successMessage);
          resolveOnce(successMessage);
        }, function error(error) {
          console.error("Serial failed to write: " + JSON.stringify(error));
          rejectOnce(error);
        });
      }, error => {
        console.error("UART list error " + JSON.stringify(error));
        var dev = "/dev/ttyS3";
        //eslint-disable-next-line no-undef
        uart.write({ dev: dev, text: text }, function success(successMessage) {
          console.error("Serial write:" + successMessage);
          resolveOnce(successMessage);
        }, function error(error) {
          console.error("Serial failed to write2: " + JSON.stringify(error));
          rejectOnce(error);
        });
      })
    } else if (c.format === "android_http") {
      var commands = text.split("\r\n").filter(c => c).map(command => "command=" + encodeURIComponent(command.substring(8)));
      let lastResponse;
      function send() {
        const command = commands.shift();
        _log(command);
        post("http://127.0.0.1:15000/Request", command, {
          Accept: "gip, deflate",
          "Content-Type": "application/x-www-form-urlencoded",
          UrlEncoded: "1"
        }).done(data => {
          lastResponse = data;
          _log(JSON.stringify(data));
          if (commands.length > 0)
            send();
          else {
            //lastResponse.success = true;
            resolveOnce(lastResponse);
          }

        }).fail(data => {
          _log(JSON.stringify(data));
          rejectOnce(data);
        })
      }
      send();
      return;

      //payment.qrcode.split("\r\n").forEach(command => {
      //})
    }
  } else {
    let url = "adminService/" + localStorage.restaurantSelected + "/sendToCashier?cashregister=" + (c ? c.id : 0) + "&lang=" + localStorage.language + (pattern ? "&pattern=" + encodeURIComponent(pattern) : "");

    let body = text;
    if (requestOptions) {
      body = JSON.stringify({
        payload: text,
        requestOptions
      });
    }

    post(url, body, undefined, isModal)
      .done(data => {
        resolveOnce(data);
      })
      .fail(data => {
        rejectOnce(data);
      });
    return;
  }
}


export const postPayment = (c, tableOccupation, tableMatePayments, printOnly, handler, errorHandler, serialDev = "", modal = true, showError = true) => {
  //eslint-disable-next-line no-undef
  //if (SerialUSB) {
  //eslint-disable-next-line no-undef
  const serial = window.serial;
  //}

  tableMatePayments.forEach(tmp => {
    if (tmp.payments) {
      if (tmp.payments.filter(p => p.amount).length === 0)
        tmp.payments = [tmp.payments[0]];
      else {
        tmp.payments = tmp.payments.filter(p => p.amount);
      }
    }
  })

  var printer = "1";
  try {
    printer = "" + (admin.getPrinterForPrinterAction("printVATInvoice")?.id || admin.getPrinterForPrinterAction("printInvoice")?.id || "1");
  } catch (ex) {
  }
  if (printer.startsWith("bt/")) {
    printer = "1";
  }
  var printerSlip = "1";
  try {
    printerSlip = "" + (admin.getPrinterForPrinterAction("printInvoice")?.id || admin.getPrinterForPrinterAction("printVATInvoice")?.id || "1");
  } catch (ex) {
  }
  if (printer.startsWith("bt/")) {
    printer = "1";
  }


  post("adminService/" + localStorage.restaurantSelected + "/" + tableOccupation + "/" + (printOnly ? "printReceipt" : "tableMatePaid") + "?cashregister=" + (c ? c.id : 0) + "&printer=" + (printer) + "&printerSlip=" + (printerSlip) + "&lang=" + localStorage.language, printOnly ? tableMatePayments[0] : tableMatePayments,
    undefined, modal, undefined, undefined, 100000, undefined).done(data => {
      if (!printOnly) {
        if (featureEnabled("pos/payFirst") && getNonLocalPrinterForPrinterAction("printInvoice") && data.tableOccupation)
          setTimeout(() => {
            admin.reprintInvoice(data.tableOccupation.tableMatePayments[0].id, localStorage.language, dd => {
              if (dd === '{"success":"true"}') {
              } else
                printHtml(dd, admin.getPrinterForPrinterAction("printInvoice").id);
            });
          }, 500);

        if (data.invoiceImage && admin.getPrinterForPrinterAction("printInvoice")) {
          printHtml(data.invoiceImage, admin.getPrinterForPrinterAction("printInvoice").id);
        }


        if (data.tableOccupation) {
          var closedTableOccupations = [];
          try { closedTableOccupations = JSON.parse(localStorage.receipts); } catch (ex) { }

          if (!Array.isArray(closedTableOccupations)) {
            closedTableOccupations = [];
          }


          try {
            closedTableOccupations = closedTableOccupations.filter(t => t?.tableOccupation?.tableMatePayments.filter(tmp => tmp.payments?.[0]?.date > new Date() - 180 * 60000).length);

            closedTableOccupations = closedTableOccupations.filter(t => t?.tableOccupation.id !== data?.tableOccupation?.id);

          } catch (ex) {
            console.error(JSON.stringify(closedTableOccupations));
            console.error(ex);
          }
          closedTableOccupations.push(data);
          saveClosedTableOccupations(closedTableOccupations);
        }


        if (data.error) {
          window.I18n = I18n;
          var error = data.error;
          if (error.startsWith("eatwithme.server.billingo.client.ApiException:")) {
            error = JSON.parse(error.split("eatwithme.server.billingo.client.ApiException:")[1]).error;
            error = admin_local[error] || error;
          } else {
            try {
              error = I18n.t(error) || error;
            } catch (Ex) {
              error = eval(data.error) || error;
            }
          }
          if (showError)
            messageDialog(I18n.t("local.error_message"), error);
          else {
            data.error = error;
          }
          handler(data);
          return;
        }
      }

      if (c?.type === "montax" && !data?.error) {
        printMontaxReceipt(c, sendToCashier);
      }


      if (c && (c.format === "android_http" || c.format === "android" || c.format === "android_bluetooth" || c.format === "android_rs232") && (auth.device.platform === "android" || auth.device.platform === "Android")) {
        if (c.format === "android_bluetooth") {
          //eslint-disable-next-line no-undef
          if (typeof bluetoothSerial === "undefined") {
            console.error("Bluetooth serial is not available");
            messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_adapter"));
            return;
          }
          //eslint-disable-next-line no-undef
          bluetoothSerial.list(success => {
            const serial = success.filter(c => c.name.startsWith("ECR-") || c.name.startsWith("VVLPTG"));
            if (serial.length === 1) {
              //eslint-disable-next-line no-undef
              bluetoothSerial.connect(serial[0].address, connectSuccess => {
                tableMatePayments.forEach(payment => {
                  if (payment.qrcode) {
                    var text = payment.qrcode;
                    if (auth.myStatus.restaurant_cash_registers.find(cc => cc.id == c.id).type !== "cashcube")
                      text = text.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    //eslint-disable-next-line no-undef
                    bluetoothSerial.write(text + "\r\n", function success() {
                      //eslint-disable-next-line no-undef
                      bluetoothSerial.disconnect(function success() { }, function error() {
                        console.error("Bluetooth Serial failed to close");
                      })
                    }, function error() {
                      console.error("Serial failed to write");
                      //eslint-disable-next-line no-undef
                      bluetoothSerial.disconnect(function success() { }, function error() {
                        console.error("Bluetooth Serial failed to close");
                      });
                    });
                  }
                });
              }, connectFailure => {
                console.error("Bluetooth serial not", connectFailure)
              });
            } else {
              if (serial.length > 1)
                messageDialog(I18n.t("local.warning"), I18n.t("admin_local.too_many_bluetooth_cashiers"));
              else
                messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_cashiers"));
            }
          }, failure => {
            console.error("Bluetooth serial error", JSON.stringify(failure));
          });
        } else if (c.format === "android") {

          const opts = {
            baudRate: 9600,
            //dtr: true,
            //rts: true,
            sleepOnPause: false
          }
          if (c && c.type === "jota_m")
            opts.parity = 1;

          //eslint-disable-next-line no-undef
          serial.requestPermission(function success() {
            console.log("Serial granted phase 2");
            //eslint-disable-next-line no-undef
            serial.open(opts, function success() {
              console.log("Serial openned phase 2");
              tableMatePayments.forEach(payment => {
                if (payment.qrcode) {
                  console.log("Trying serial write:" + payment.qrcode);
                  //eslint-disable-next-line no-undef
                  serial.write(payment.qrcode + "\r\n", function success(successMessage) {
                    console.log("Serial write:" + successMessage);
                    /*
                    setTimeout(() => {
                      //eslint-disable-next-line no-undef
                      serial.close(function success() {
                        console.error("Serial closed");
                      }, function error() {
                        console.error("Serial failed to close");
                      })
                    }, 4000);
                    */
                  }, function error() {
                    console.error("Serial failed to write");
                    //eslint-disable-next-line no-undef
                    serial.close(function success() { }, function error() {
                      console.error("Serial failed to close");
                    });
                  });
                }
              })

            }, function error(error) {
              console.error("Serial failed to open(1)", error);
            });
          }, function error(error) {
            console.error("Serial denied", error);
          });
        } else if (c.format === "android_rs232") {
          tableMatePayments.forEach(payment => {
            //eslint-disable-next-line no-undef
            uart.list(dev => {
              _log(payment.qrcode);
              //eslint-disable-next-line no-undef
              uart.write({ dev: dev, text: payment.qrcode }, function success(successMessage) {
                console.error("Serial write:" + successMessage);
              }, function error(error) {
                console.error("Serial failed to write: " + JSON.stringify(error));
              });
            }, error => {
              console.error("UART list error " + JSON.stringify(error));
              var dev = "/dev/ttyS3";
              //eslint-disable-next-line no-undef
              uart.write({ dev: dev, text: payment.qrcode }, function success(successMessage) {
                console.error("Serial write:" + successMessage);
              }, function error(error) {
                console.error("Serial failed to write2: " + JSON.stringify(error));
              });
            })
          });
        } else if (c.format === "android_http") {

        }
      }

      handler(data);
    }).fail(data => {
      errorHandler && errorHandler(data);
      if (data.status == 400) {
        handler(data);
        return;
      } else {
        if (auth.recoverFromError)
          auth.recoverFromError();
      }

      ajaxCallEnd();
      auth.ajaxError = false;
      if (data.responseJSON) {
        data = data.responseJSON;
      } else if (data.responseText) {
        try {
          data = JSON.parse(data.responseText);
        } catch (ex) {
          _log("Failed to parse JSON:" + data.responseText);
          data = JSON.parse(data.responseText.replaceAll("\t", "").replaceAll("\n", " ").replaceAll("\r", ""));
        }
      }
      try {
        var e = I18n.t(data.error).trim();
        if (e) {
          messageDialog(I18n.t("local.error_message"), e);
        } else {
          messageDialog(I18n.t("local.error_message"), admin_local[data.error] || data.error);
        }
      } catch (ex) {
        messageDialog(I18n.t("local.error_message"), admin_local[data.error] || data.error);
      }
      handler(data);
      //console.error(data);
    });
}

export const reprintReceipts = () => {
  if (typeof localStorage.receipts === "undefined")
    saveClosedTableOccupations([]);
  var modal = $("#tableMatePaidDialog");
  modal.empty();
  var closedTableOccupations = JSON.parse(localStorage.receipts).filter(t => t?.tableOccupation?.tableMatePayments.length > 0);

  if (!Array.isArray(closedTableOccupations)) {
    closedTableOccupations = [];
  }

  closedTableOccupations.reverse();

  closedTableOccupations.forEach(t => {
    t.tableOccupation.tableMatePayments.forEach(tmp => {
      if (tmp.invoice === undefined)
        tmp.invoice = false;
    });
  });

  $("#reprintReceiptsTemplate")
    .tmpl({
      closedTableOccupations: closedTableOccupations,
      ...tmplparams()
    })
    .appendTo(modal)
  var modal = $("#tableMatePayments.modal");

  function updateStorno() {
    var cashregister = Number($("#cashregisters input:checked").prop("id"));
    cashregister = auth.myStatus.restaurant_cash_registers.find(c => c.id === cashregister);
    modal.find("#dayCloseReprint").toggleClass("hidden", !["montax", "a234", "b1"].includes(cashregister?.type));
    if (cashregister) {
      switch (cashregister.type) {
        case "fiscat":
        case "fiscat2":
        case "fiscat3":
        case "fiscat3a":
        case "fiscat4":
        case "fiscat5":
        case "a234":
        case "montax":
        case "b1":
          modal.find("#dayOpen").removeClass("hidden");
          modal.find("#dayClose").removeClass("hidden");
          modal.find("#storno").removeClass("hidden");
          modal.find("#cashin").removeClass("hidden");
          modal.find("#cashout").removeClass("hidden");
          break;
        case "sam4s":
          modal.find("#dayOpen").removeClass("hidden");
          modal.find("#dayClose").removeClass("hidden");
          modal.find("#storno").addClass("hidden");
          modal.find("#cashin").removeClass("hidden");
          modal.find("#cashout").removeClass("hidden");
          break;
        case "sam4s2":
          modal.find("#dayOpen").removeClass("hidden");
          modal.find("#dayClose").removeClass("hidden");
          modal.find("#storno").removeClass("hidden");
          modal.find("#cashin").removeClass("hidden");
          modal.find("#cashout").removeClass("hidden");
          break;
        default:
          modal.find("#storno").addClass("hidden");
          modal.find("#cashin").addClass("hidden");
          modal.find("#cashout").addClass("hidden");
          modal.find("#dayOpen").addClass("hidden");
          modal.find("#dayClose").addClass("hidden");
          break;
      }
    } else {
      modal.find("#storno").addClass("hidden");
      modal.find("#cashin").addClass("hidden");
      modal.find("#cashout").addClass("hidden");
      modal.find("#dayOpen").addClass("hidden");
      modal.find("#dayClose").addClass("hidden");
    }
  }
  updateStorno();
  modal.find("#cashregisters input").on("change", updateStorno);
  modal.show();
}

export const reprintReceipt = (tableMatePaymentId, storno = false) => {
  var data = JSON.parse(localStorage.receipts);
  if (!Array.isArray(data)) {
    data = [];
  }

  var data = data.find(tableOccupation => tableOccupation.tableOccupation.tableMatePayments.find(tmp => tmp.id === tableMatePaymentId));
  if (!data)
    return;
  var tableMatePayment = data.tableOccupation.tableMatePayments.find(tmp => tmp.id === tableMatePaymentId);
  if (!tableMatePayment)
    return;
  const paymentCashRegisterId = tableMatePayment.payments?.[0]?.cashRegister?.id;
  const paymentCashRegister = auth.myStatus.restaurant_cash_registers.find(c => c.id == paymentCashRegisterId);
  if (storno) {
    if (paymentCashRegister?.type === "montax" && tableMatePayment.stornoReceiptNo) {
      confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.reprint_receipt")).done(() => {
        reprintMontaxReceipt(paymentCashRegister, tableMatePayment.stornoReceiptNo, sendToCashier, "VOID_RECEIPT");
      });
    }
    return;
  }
  if (paymentCashRegister?.type === "montax" && tableMatePayment.receiptNo) {
    // The fiscal document already exists on the device, download and print it again instead of creating a new one.
    confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.reprint_receipt")).done(() => {
      reprintMontaxReceipt(paymentCashRegister, tableMatePayment.receiptNo, sendToCashier);
    });
    return;
  }
  if ((paymentCashRegister?.type === "a234" || paymentCashRegister?.type === "b1") && tableMatePayment.receiptNo) {
    // The fiscal receipt is stored in the electronic journal of the device, print that copy instead of creating a new receipt.
    const request = paymentCashRegister.type === "b1"
      ? reprintReceipt_b1(tableMatePayment.receiptNo)
      : reprintReceipt_a234(tableMatePayment.receiptNo);
    if (request) {
      confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.reprint_receipt")).done(() => {
        sendToCashier(paymentCashRegister, request.text, request.pattern, false, null, () => {
          messageDialog(I18n.t("local.warning"), I18n.t("admin_local.kiosk_cash_register_communication_unsuccessful"));
        });
      });
      return;
    }
  }
  tableMatePayment.orders = data.orders.filter(o => tableMatePayment.orderIds.split(",").find(oo => oo == o.id));
  function doit() {
    getQrcodeCode(tableMatePayment).done(url => {
      var cashregister = $("#cashregisters input:checked").prop("id");
      cashregister = auth.myStatus.restaurant_cash_registers.find(c => c.id == cashregister);
      const tableMatePayments = {
        id: tableMatePaymentId,
        tableOccupation: data.tableOccupation.id,
        qrcode: url
      }
      if (cashregister && (cashregister.format === "http" || cashregister.format === "rs232"))
        postPayment(cashregister, data.tableOccupation.id, [tableMatePayments], true, (data) => {
        })
      else
        sendToCashier(cashregister, url);
      ///update(data);
      //reprintReceipts();
    })
  }
  if (tableMatePayment.printed) {
    confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.reprint_receipt")).done(doit);
  } else
    doit();

}

export const registerTip = (tableMatePaymentId) => {
  const data = JSON.parse(localStorage.receipts);
  const tableOccupation = data.find(t => t.tableOccupation.tableMatePayments.find(tmp => tmp.id === tableMatePaymentId));
  const tableMatePayment = tableOccupation.tableOccupation.tableMatePayments.find(tmp => tmp.id === tableMatePaymentId);
  redoTableMatePaid(tableMatePayment, tableOccupation.orders, (d) => {
  });
}

export const stornoReceipt = (tableOccupationId, tableMatePaymentId, receiptNo, cashRegister, handler) => {
  storno(tableOccupationId, tableMatePaymentId, receiptNo, cashRegister).done(data => {
    if (data.tableOccupation) {
      update(data);
      var closedTableOccupations = [];
      try { closedTableOccupations = JSON.parse(localStorage.receipts); } catch (ex) { }

      if (!Array.isArray(closedTableOccupations)) {
        closedTableOccupations = [];
      }


      try {
        //closedTableOccupations = closedTableOccupations.filter(t => t?.tableOccupation?.tableMatePayments.filter(tmp => tmp.payments[0].date > new Date() - 30 * 60000).length);

        closedTableOccupations = closedTableOccupations.filter(t => t?.tableOccupation.id !== data?.tableOccupation?.id);

      } catch (ex) {
        console.error(JSON.stringify(closedTableOccupations));
        console.error(ex);
      }
      if (!data.error)
        closedTableOccupations.push(data);

      saveClosedTableOccupations(closedTableOccupations);

      const stornoedPayment = data.tableOccupation.tableMatePayments?.find(tmp => tmp.id === tableMatePaymentId);
      const stornoCashRegister = auth.myStatus.restaurant_cash_registers.find(c => c.id == (cashRegister || stornoedPayment?.payments?.[0]?.cashRegister?.id));
      const stornoReceiptNo = data.stornoReceiptNo || stornoedPayment?.stornoReceiptNo;
      if (!data.error && stornoCashRegister?.type === "montax" && stornoReceiptNo) {
        reprintMontaxReceipt(stornoCashRegister, stornoReceiptNo, sendToCashier, "VOID_RECEIPT");
      }
      handler && handler();
    }
  });
}


export const selectTerminal = (type) => {
  const choices = auth.myStatus.restaurant_bank_terminals.filter(t => t.type === type && (!t.format.startsWith("android") || (t.format.startsWith("android") && auth.device.platform === "Android"))).map(t => t.name);
  choiceDialog2(I18n.t("local.request"), I18n.t("admin_local.choose_terminal_to_use"), choices).done(choice => {
    localStorage.setItem(type + "_terminal", choices[choice]);
    $(".input-group.amountPaid[paymentMethodType = '" + type + "'] button.paymentMethod .terminal").html(localStorage.getItem(type + "_terminal"));
  });
}

export const setServiceFee = (tableMateId, serviceFee) => {
  const tableMate = { ...getTableMate(tableMateId), service: serviceFee };
  post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", [tableMate]).done(data => {
    update(data);
    tableMatePaid();
    //showPayments();
  });
}

export const getCompanyByTaxId = (taxid, tableMateId) => {
  get("billingo/" + localStorage.restaurantSelected + "/company/" + encodeURIComponent(taxid)).done(data => {
    if (data) {
      // Handle the retrieved company data
      console.log("Company data:", data);
      const m = $("#" + tableMateId + ".mate.list-group-item");
      m.find("input#name").val(data.name);
      document.getElementById("name").dispatchEvent(new Event("keyup", { bubbles: true }));
      m.find("input#address").val(data.address);
      document.getElementById("address").dispatchEvent(new Event("keyup", { bubbles: true }));
      m.find("input#city").val(data.town);
      document.getElementById("city").dispatchEvent(new Event("keyup", { bubbles: true }));
      m.find("input#postcode").val(data.postcode);
      document.getElementById("postcode").dispatchEvent(new Event("keyup", { bubbles: true }));
    } else {
      console.error("No company found");
    }
  }).fail(error => {
    auth.ajaxError = false;
  });
}

window.getCompanyByTaxId = getCompanyByTaxId;
